var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(_vm.iscn)?_c('div',{staticClass:"footer"},[_c('div',{staticClass:"text"},[_vm._v("和转转一起拯救世界，让世界因流转更可持续！")])]):_vm._e(),(!_vm.iscn)?_c('div',{staticClass:"footer"},[_c('div',{staticClass:"text text-en"},[_vm._v("Assemble，strive for a more sustainable world！")])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }